import logWarn from './logger/warn';
import logError from './logger/error';



const translations = window.SPM_I18N || {};

const translate = (phrase, params = {}) => {
  let translation;

  if (!translations.hasOwnProperty(phrase)) {
    if (__ASSERTS_ENABLED__) {
      logWarn(`has no translation for "${phrase}"`);
    }
    translation = phrase;
  } else {
    translation = translations[phrase];
  }

  if (/\{%\s*([^\s%]*)\s*%}/g.test(translation)) {
    translation = translation.replace(/\{%\s*([^\s%]*)\s*%}/g, ($0, $1) => {
      if (params.hasOwnProperty($1)) {
        return params[$1];
      }

      if (__ASSERTS_ENABLED__) {
        logError(`undefined translation param "${$1}"`);
      }

      return '';
    });
  }

  return translation;
};

window.__ = translate;

export const rtlLocales = [ 'ar', 'he' ];



// WEBPACK FOOTER //
// ./src/lib/locale.js